/**
 * Breakpoints chosen to cover iPhone (≤430px) and tablet (431–1366px) ranges.
 * iPad Pro and Android tablets such as Galaxy Tab S7 can report landscape
 * widths above 1200px, so the tablet cap includes common 1280/1366px viewports.
 * Adjust if your design needs a wider tablet range.
 */
export const RESPONSIVE_BREAKPOINTS = {
  iphoneMaxWidth: 430,
  ipadMaxWidth: 1366,
};

export const RESPONSIVE_QUERIES = {
  iphone: `(max-width: ${RESPONSIVE_BREAKPOINTS.iphoneMaxWidth}px)`,
  ipad: `(min-width: ${RESPONSIVE_BREAKPOINTS.iphoneMaxWidth + 1}px) and (max-width: ${RESPONSIVE_BREAKPOINTS.ipadMaxWidth}px)`,
  desktop: `(min-width: ${RESPONSIVE_BREAKPOINTS.ipadMaxWidth + 1}px)`,
};

export type ResponsiveDevice = 'iphone' | 'ipad' | 'desktop';
